module.exports = __webpack_public_path__ + "static/media/clock-benefit-icon.e6e83de5.svg";